import Cookies from "js-cookie";

export const getCookie=()=>{
    const accessTokenCookie = Cookies.get('accessToken'); 
    const refreshTokenCookie = Cookies.get('refreshToken'); 
    const accessToken =localStorage.getItem('accessToken')
    const refreshToken =localStorage.getItem('refreshToken')
    return {accessToken:accessTokenCookie||accessToken, refreshToken:refreshTokenCookie||refreshToken}
}

export const setCookieWithLocalStorage=(accessToken:any,refreshToken:any )=>{
    // const domain= process.env.REACT_APP_API_DOMAIN;
    // const https= process.env.REACT_APP_API_DOMAIN;
    document.cookie = `accessToken=${accessToken}; path=/; max-age=${3600} ;secure; SameSite=None`; // 1 цаг
    document.cookie = `refreshToken=${refreshToken}; path=/; max-age=${7 * 24 * 60 * 60} ;secure; SameSite=None`; // 7 хоног
    localStorage.setItem('accessToken', accessToken);
    localStorage.setItem('refreshToken', refreshToken);
}


export const removeCookieWithLocalStorage=()=>{
    document.cookie = "accessToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    document.cookie = "refreshToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
}

